import React, {memo, useState} from "react";
import Form from "./form";
import {Table, Pagination, Button} from "react-bootstrap";
import Swal from "sweetalert2";
import axios from 'axios';
import moment from "moment/moment";

function DataTable({response, setPage, change, setChange, deleteItem}) {
    const [show, setShow] = useState(false);
    const [contentData, setContentData] = useState();


    const editItem = async (userId) => {
        await axios.get(`${process.env.REACT_APP_API_URL}/user/${userId}`)
            .then(function (response) {
                if (response.data.status === true) {
                    console.log(response);
                    setContentData(response.data.data);
                    setShow(true);
                } else {
                    console.log(response);
                }
            });
    }

    const updateStatus = async (contentId, userId, contentStatus) => {
        await axios.post(`${process.env.REACT_APP_API_URL}/content/status/${contentId}/${userId}/${contentStatus}`)
            .then(function (response) {
                setChange(change + 1);
                if (response.data.status === true) {
                    Swal.fire({
                        text: "İşlem başarıyla tamamlandı.",
                        icon: "success",
                        confirmButtonText: "Tamam",
                    });
                } else {
                    console.log(response);
                    Swal.fire({
                        text: response.data.message,
                        icon: "error",
                        confirmButtonText: "Tamam",
                    });
                }
            });
    }

    return (
        <>
            <div className="bg-white rounded border mb-3">
                <Table hover responsive className="mb-0">
                    <thead>
                    <tr>
                        <th>Başlık</th>
                        <th>Tarih</th>
                        <th>Site</th>
                        <th>Kelime</th>
                        <th>Ücret</th>
                        <th>Editör</th>
                        <th>Durum</th>
                        <th></th>
                    </tr>
                    </thead>
                    <tbody>

                    {response.data && (response.data).map((element) => (
                        <tr key={element.contentId}>
                            <td>{element.contentTitle}</td>
                            <td>{element.contentDate ? moment(element.contentDate).format("DD MMMM YYYY") : null }</td>
                            <td>{element.siteName}</td>
                            <td>{element.contentWordCount > 0 ? element.contentWordCount : "-"}</td>
                            <td>{element.contentPrice > 0 ? element.contentPrice + "₺" : "-"}</td>
                            <td>{element.userName != null ? element.userName : "-"}</td>
                            <td>


                                {element.contentStatus == 0 ? <small
                                    className={"bg-primary rounded px-2 py-1 text-white fs-8"}>Müsait</small> : ""}
                                {element.contentStatus == 1 ?
                                    <small className={"bg-warning rounded px-2 py-1 text-white fs-8"}>Dolu</small> : ""}
                                {element.contentStatus == 2 ? <small
                                    className={"bg-dark rounded px-2 py-1 text-white fs-8"}>Onay Aşamasında</small> : ""}
                                {element.contentStatus == 3 ? <small
                                    className={"bg-success rounded px-2 py-1 text-white fs-8"}>Yayınlandı</small> : ""}
                                {element.contentStatus == 4 ? <small
                                    className={"bg-danger rounded px-2 py-1 text-white fs-8"}>Gizli</small> : ""}
                            </td>
                            <td className="text-end">
                                <a target={"_blank"} href={`${process.env.REACT_APP_API_URL}/content/view/${element.contentId}`} className="btn btn-primary py-0 px-2 me-2">Önizle</a>

                                {element.contentStatus == 0 ?
                                    <Button variant="dark" className="py-0 px-2 me-2" onClick={() =>
                                        Swal.fire({
                                            html: `<strong>${element.contentTitle}</strong> yazısını almak istiyor musunuz?`,
                                            icon: "question",
                                            confirmButtonText: "Evet",
                                            showCancelButton: true,
                                            cancelButtonText: "Hayır",
                                            allowEnterKey: false,
                                            preConfirm: () => {
                                                updateStatus(element.contentId, localStorage.getItem('userId'), 1);
                                            }
                                        })
                                    }>Seç</Button>
                                    : null}

                                {element.contentStatus == 1 && element.contentEditorId == localStorage.getItem('userId') ?
                                    <Button variant="dark" className="py-0 px-2 me-2" onClick={() =>
                                        Swal.fire({
                                            html: `<strong>${element.contentTitle}</strong> yazısını bırakmak istiyor musunuz?`,
                                            icon: "question",
                                            confirmButtonText: "Evet",
                                            showCancelButton: true,
                                            cancelButtonText: "Hayır",
                                            allowEnterKey: false,
                                            preConfirm: () => {
                                                updateStatus(element.contentId, 0, 0);
                                            }
                                        })
                                    }>Bırak</Button>
                                    : null}


                                {element.contentEditorId == localStorage.getItem('userId') || localStorage.getItem('userRole') > 0 ?
                                    <Button variant="dark" className="py-0 px-2 me-2"
                                            onClick={() => window.location.href=`/content/${element.contentId}`}>Düzenle</Button>
                                    :
                                    null
                                }

                                {localStorage.getItem('userRole') > 0 &&
                                    <Button variant="danger" className="py-0 px-2" onClick={() =>
                                        Swal.fire({
                                            html: `<strong>${element.contentTitle}</strong> içeriğini silmek istiyor musun?`,
                                            icon: "question",
                                            confirmButtonText: "Evet",
                                            showCancelButton: true,
                                            cancelButtonText: "Hayır",
                                            allowEnterKey: false,
                                            preConfirm: () => {
                                                deleteItem(element.contentId);
                                            }
                                        })
                                    }>Sil</Button>
                                }

                            </td>
                        </tr>
                    ))}

                    </tbody>
                </Table>
            </div>
            <Pagination>
                {Array.from({length: response.pageCount}, (item, index) =>
                    <Pagination.Item key={index} onClick={(page) => setPage(index + 1)}
                                     active={response.page === index}>{(index + 1)}</Pagination.Item>
                )}
            </Pagination>

            {show &&
                <Form change={change} setChange={setChange} show={show} setShow={setShow} contentData={contentData}/>}
        </>
    )

}

export default memo(DataTable);
